import { render, staticRenderFns } from "./ChangePasswordModal.vue?vue&type=template&id=3b03e353&scoped=true"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=js"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=js"
import style1 from "./ChangePasswordModal.vue?vue&type=style&index=1&id=3b03e353&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b03e353",
  null
  
)

export default component.exports